import "./input.css";
import "./main.css";
import "./index.css";
import "antd/dist/reset.css";
// import "./assets/styles/main.css";
// import "./assets/styles/responsive.css";
// import "./assets/styles/style.css";
import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import Router from "./route/router";

/* รูปแบบวันที่ที่ใช้ทั้งระบบ (เฉพาะการแสดงผล/กรอกข้อมูล)
   ค่าที่ส่งเข้า API ยังเป็น YYYY-MM-DD เหมือนเดิม */
const DATE_FORMAT = "DD/MM/YYYY";

const appLocale = {
  ...enUS,
  DatePicker: {
    ...enUS.DatePicker,
    lang: {
      ...enUS.DatePicker.lang,
      dateFormat: DATE_FORMAT,
      fieldDateFormat: DATE_FORMAT,
      dateTimeFormat: `${DATE_FORMAT} HH:mm:ss`,
      fieldDateTimeFormat: `${DATE_FORMAT} HH:mm:ss`,
    },
  },
};

function App() {
  return (
    <ConfigProvider locale={appLocale}>
      <div className="App">
        <Router />
      </div>
    </ConfigProvider>
  );
}

export default App;
